export default __webpack_public_path__ + "static/mastercard-a7a8e373f7a43a013801eefd5be61f2b.svg";